import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { catchError, mergeMap, Observable, tap, throwError } from 'rxjs';
import { AppAuthService } from './app-auth.service';
import { Router } from '@angular/router';
import { SabisToaster2Service } from 'sabis-components2';

@Injectable()
export class HttpAuthInterceptor implements HttpInterceptor {

  constructor(private authService: AppAuthService, private _router: Router, private _toaster: SabisToaster2Service) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    /** If token has been already requested or file stored on azure is requested -> continue with the current request */
    let shouldSkipAuth: boolean = request.url.indexOf('token') > -1 || request.url.indexOf('blob.core.windows.net') > -1;

    if (shouldSkipAuth) {
      const modifiedRequest = request.clone();
      return next.handle(modifiedRequest);
    }

    return this.authService.getAccessToken().pipe(mergeMap(token => {
      let dateOffset = (new Date().getTimezoneOffset()) * -1;

      /** Modify the request or perform any desired operations */
      const modifiedRequest = request.clone({
        setHeaders: {
          'Authorization': 'Bearer ' + token,
          'app-dateoffset': dateOffset.toString()
        }
      });

      /** Pass the modified request to the next handler */
      return next.handle(modifiedRequest).pipe(catchError(httpError => {
        /** If 401 unauthorized navigate to login */
        if (httpError.status == 401) {
          this._router.navigateByUrl("login");
        }

        if (httpError instanceof HttpErrorResponse && httpError.error && !httpError.error.IsSucceeded && httpError.error.Errors && httpError.error.Errors.length > 0) {
          // get error from json (errors.json file backend)
          var error = httpError.error.Errors[0];
          this._toaster.showError(error.ErrorMessage);
        }

        throw new Error(httpError);
      }
      ),
        tap(r => {
          if (r instanceof HttpResponse && r.body && !r.body.isSucceeded && r.body.errors && r.body.errors.length > 0) {
            // get error from json (errors.json file backend)
            var error = r.body.errors[0];
            this._toaster.showError(error.errorMessage);
          }
        })
      );
    }))
  }
}
